import Container from "@/components/ui/container"
import { H1 } from "@/components/ui/headings"
import Panel from "@/components/ui/panel"
import { useToast } from "@/components/ui/use-toast"
import { gql } from "@/generated"
import { MainLayout } from "@/novus/layouts/MainLayout"
import { rootPath } from "@/novus/novus-paths"
import { useMutation } from "@apollo/client"
import React from "react"
import { SubmitHandler } from "react-hook-form"
import { useNavigate } from "react-router-dom"
import DeductionForm, { DeductionFormValues } from "./components/DeductionForm"

const CreateDeduction_Mutation = gql(`
  mutation CreateDeduction($input: CreateDeductionInput!) {
    createDeduction(input: $input) {
      deduction {
        ...ProfileDeductionFragment
      }
      errors {
        path
        fullMessages
      }
    }
  }
`)

const AddDeductionScreen = () => {
  const { toast } = useToast()
  const [mutate] = useMutation(CreateDeduction_Mutation)
  const navigate = useNavigate()

  const defaultValues: DeductionFormValues = {
    fiveTwoNineAccountId: "",
    amount: "",
  }

  const onSubmit: SubmitHandler<DeductionFormValues> = async (values) => {
    const { data } = await mutate({
      variables: {
        input: {
          fiveTwoNineAccountId: values.fiveTwoNineAccountId,
          amountCents: Number(values.amount) * 100,
        },
      },
    })

    if (
      data?.createDeduction.errors &&
      data?.createDeduction.errors.length > 0
    ) {
      throw data?.createDeduction.errors
    }

    toast({
      title: "Deduction has been added.",
    })

    navigate(rootPath.pattern)
  }

  return (
    <MainLayout>
      <Container>
        <Panel backPath={rootPath.pattern} minHeight={true}>
          <div className="text-center mb-14">
            <H1>Add Monthly Deduction</H1>
          </div>
          <DeductionForm
            onSubmit={onSubmit}
            defaultValues={defaultValues}
            isNew={true}
          />
        </Panel>
      </Container>
    </MainLayout>
  )
}

export default AddDeductionScreen
